export default __webpack_public_path__ + "static/media/chart.99277b56.PNG";